module.exports = __webpack_public_path__ + "media/images/new/icons/checkmark-241c4a16eb29574ca3b0d0dff3cfb0b7.svg";